import { create } from "zustand";
import { persist, createJSONStorage, subscribeWithSelector } from 'zustand/middleware'
import { createAppSlice, AppSlice } from "./app-slice.ts";
import { createPropertySlice, PropertySlice } from "./property-slice.ts";
import { ApiSlice, createApiSlice } from "./api-slice.ts";

console.log("esr-core: 1.5");

export const useStore = create<AppSlice & ApiSlice & PropertySlice>()(
  persist(
    subscribeWithSelector((...a) => ({
    ...createAppSlice(...a),
    ...createApiSlice(...a),
    ...createPropertySlice(...a),
    })),
    {
      name: 'esr-state-storage-'+window.location.host.replace(/[\./]/g,''),
      version: Date.now(),
      migrate: (persistedState, version) => {
        if (Date.now() - version > 0) { //86400000
          return {};
          //return {...persistedState as object}
        }
        return persistedState
      },
      onRehydrateStorage: (_state) => {
        return (_state, _error) => {
          async function init_request(){
            //console.log("loading state");
          }
          init_request();
        }
      },  
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => 
            !['config', 'translation', 'modal_ref', 'modals'].includes(key)
        )),
      storage: createJSONStorage(() => localStorage),
    }
  ));


  
let session_token_events : Array<()=> void> = [];

export function add_session_token_handler(handler: ()=>void){
  const session_token = useStore.getState().session_token
  if (session_token){
    handler()
  }else{
    session_token_events.push(handler);
  }
}

export function on_session_token(){
  while (session_token_events.length > 0) {
    const handler = session_token_events.pop();
    handler!();
  }
}

const _ = useStore.subscribe(
  (state) => state.session_token,
  (_session_token, _) => on_session_token()
)